import { Loader2 } from "lucide-react";

interface MapPreviewProps {
  address: string;
  mapEmbedUrl: string | null;
  isLoadingKey: boolean;
  mapsApiKey: string | null;
}

export const MapPreview = ({
  address,
  mapEmbedUrl,
  isLoadingKey,
  mapsApiKey
}: MapPreviewProps) => {
  return (
    <div className="space-y-2">
      <div className="border rounded-md overflow-hidden w-full h-[200px]">
        {isLoadingKey ? (
          <div className="flex items-center justify-center h-full text-muted-foreground bg-muted/30">
            <div className="flex items-center gap-2">
              <Loader2 className="h-4 w-4 animate-spin" />
              <span className="text-sm">Loading map...</span>
            </div>
          </div>
        ) : mapsApiKey && mapEmbedUrl ? (
          <iframe 
            src={mapEmbedUrl}
            width="100%" 
            height="100%" 
            style={{ border: 0 }} 
            allowFullScreen={false}
            loading="lazy" 
            referrerPolicy="no-referrer-when-downgrade"
            title={`Map preview for ${address}`}
          />
        ) : (
          <div className="flex items-center justify-center h-full text-muted-foreground bg-muted/30">
            <span className="text-sm">Map preview not available</span>
          </div>
        )}
      </div>
    </div>
  );
};